

export enum  ActionsTypes{
    SET_TIME_RANGE = "SET_TIME_RANGE",
    SET_IS_LOADING = "SET_IS_LOADING"
}